import { useCallback } from 'react';

import { useDispatch } from 'react-redux';

import { useTracking } from 'hooks/useTracking';

import {
  QueueStory,
  removeAllFromQueue,
  removeAllFromRecommendations,
  removeFromQueue,
  removeFromRecommendations,
} from 'store/modules/queue';

export const useQueueRemoval = () => {
  const dispatch = useDispatch();
  const { trackContentInteraction } = useTracking();

  const onRemoveFromQueue = useCallback(
    ({ index, item }: { index: number; item: QueueStory }) => {
      dispatch(removeFromQueue(index));

      trackContentInteraction(
        'click',
        'remove-from-queue-button',
        `remove-from-queue-button_${item.id}_${index}`,
      );
    },
    [dispatch, trackContentInteraction],
  );

  const onRemoveAllFromQueue = useCallback(() => {
    dispatch(removeAllFromQueue());

    trackContentInteraction(
      'click',
      'remove-all-from-queue-button',
      'remove-all-from-queue-button',
    );
  }, [dispatch, trackContentInteraction]);

  const onRemoveFromRecommendations = useCallback(
    ({ index, item }: { index: number; item: QueueStory }) => {
      dispatch(removeFromRecommendations(index));

      trackContentInteraction(
        'click',
        'remove-from-queue-recommendations-button',
        `remove-from-queue-recommendations-button_${item.id}_${index}`,
      );
    },
    [dispatch, trackContentInteraction],
  );

  const onRemoveAllFromRecommendations = useCallback(() => {
    dispatch(removeAllFromRecommendations());

    trackContentInteraction(
      'click',
      'remove-all-from-queue-recommendations-button',
      'remove-all-from-queue-recommendations-button',
    );
  }, [dispatch, trackContentInteraction]);

  return {
    onRemoveFromQueue,
    onRemoveAllFromQueue,
    onRemoveFromRecommendations,
    onRemoveAllFromRecommendations,
  };
};
